import { Button, Modal, Text } from "@marketplace/ui";
import { notifications } from "@marketplace/ui/notifications";
import { useQueryClient } from "@tanstack/react-query";
import { useAtomValue } from "jotai";
import { useResetAtom } from "jotai/utils";
import { useTranslation } from "react-i18next";

import { claimDeleteModalAtom } from "../../atoms/claim-delete-modal-atom";
import { OrderQueryKeys } from "../../generators/order-query-keys";
import { useDeleteClaimMutation } from "../../hooks/mutations/use-delete-claim-mutation";

export const ClaimDeleteModal = () => {
  const { visible, claim, kind } = useAtomValue(claimDeleteModalAtom);
  const resetModal = useResetAtom(claimDeleteModalAtom);
  const { t: tCommon } = useTranslation("common");
  const { t } = useTranslation("order", {
    keyPrefix: `claimHistoryPage.${kind}Modal`
  });
  const queryClient = useQueryClient();

  const { mutate, isPending } = useDeleteClaimMutation({
    options: {
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: OrderQueryKeys.getClaimHistoryList._def
        });
        await queryClient.invalidateQueries({
          queryKey: OrderQueryKeys.getClaimHistoryBadgeCount._def
        });
        notifications.show({
          message: t("successMessage")
        });
        resetModal();
      }
    }
  });

  const handleDelete = () => {
    if (!claim) return;
    mutate({ claimId: claim.id });
  };

  return (
    <Modal.Root opened={visible} onClose={resetModal} size={345}>
      <Modal.Overlay />
      <Modal.Content>
        <Modal.Body classNames={{ body: "!p-6" }}>
          <Text
            type="paragraph"
            className="text-center text-fjord-grey-400 mb-6"
          >
            {t("description")}
          </Text>
          <div className="flex gap-x-[14px]">
            <Button variant="secondary" fullWidth onClick={resetModal}>
              {tCommon("no")}
            </Button>
            <Button
              variant="primary"
              fullWidth
              loading={isPending}
              onClick={handleDelete}
            >
              {tCommon("yes")}
            </Button>
          </div>
        </Modal.Body>
      </Modal.Content>
    </Modal.Root>
  );
};
